/* This example requires Tailwind CSS v2.0+ */
import { useRouter } from "next/router";
import Layout from "../components/Layout";
import PricingTable from "../components/PricingTable";
import SEO from "../components/SEO";
import { classNames } from "../utils/formatters";

function Individual() {
  return (
    <div className="mt-8">
      <div className="sm:flex sm:flex-col sm:align-center">
        <h1 className="text-5xl font-extrabold text-gray-900 sm:text-center">
          Publicaciones individuales
        </h1>
        <p className="mt-5 text-xl text-gray-500 sm:text-center">
          Escogé el tipo de publicación que mejor se adapte a tu presupuesto y
          tus necesidades.
        </p>
      </div>
      <div className="mt-6">
        <PricingTable />
      </div>
    </div>
  );
}

function Business() {
  return (
    <div className="mt-8">
      <div className="sm:flex sm:flex-col sm:align-center">
        <h1 className="text-5xl font-extrabold text-gray-900 sm:text-center">
          Paquetes para negocios
        </h1>
        <p className="mt-5 text-xl text-gray-500 sm:text-center">
          Pagá únicamente por lo que necesitás, cuando lo necesités, sin
          subscripciones ni costos mensuales fijos. <br />
        </p>
      </div>
      <div className="mt-6">
        <PricingTable hideFree bundle />
      </div>
    </div>
  );
}

const TABS = ["individual", "business"];
export default function Pricing() {
  const router = useRouter();
  const { tab } = router.query;

  function onTabClick(e) {
    const tab = e.target.id;
    router.replace(
      {
        pathname: "/pricing",
        query: { tab },
      },
      undefined,
      { shallow: true }
    );
  }

  return (
    <>
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/pricing${
          tab ? `?tab=${tab}` : ""
        }`}
        title={
          tab === TABS[1]
            ? "Precios de nuestros destacados para negocios"
            : "Precios de nuestros destacados"
        }
        siteTitle="Movi Autos"
      />
      <div className="bg-white">
        <div className="max-w-7xl mx-auto pt-8 sm:pt-12 pb-6 px-4 ">
          <span className="relative z-0 flex justify-center rounded-md">
            <button
              id={TABS[0]}
              type="button"
              className={classNames(
                "relative inline-flex items-center px-6 py-2 rounded-l-md border border-gray-300  text-lg font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 disabled:opacity-40 disabled:cursor-not-allowed",
                tab !== TABS[1] ? "bg-gray-50 text-orange-500" : "text-gray-700"
              )}
              onClick={onTabClick}
            >
              Individuales
            </button>
            <button
              id={TABS[1]}
              type="button"
              className={classNames(
                "-ml-px relative inline-flex items-center px-6 py-2 rounded-r-md border border-gray-300 bg-white text-lg font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 disabled:opacity-40 disabled:cursor-not-allowed",
                tab === TABS[1] ? "bg-gray-50 text-orange-500" : "text-gray-700"
              )}
              onClick={onTabClick}
            >
              Negocios
            </button>
          </span>
          {tab === TABS[1] ? <Business /> : <Individual />}
        </div>
      </div>
    </>
  );
}

Pricing.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
